import { useDispatch } from 'react-redux';
import { useOrderType } from 'routes/secondary-market-batch/hooks/use-order-type';
import { secondaryMarketBatchActions } from 'state/workspaces/secondary-market/batch/actions';
import { SearchType } from 'state/workspaces/secondary-market/batch/model';

export function useSwitchOrderSearchType() {
  const { orderType } = useOrderType();
  const dispatch = useDispatch();

  return (searchType: SearchType) => {
    dispatch(secondaryMarketBatchActions.searchTypeChanged(orderType, searchType));
  };
}
